import React from "react";
import { LoaderRing } from "..";
import "./loading_widget.scss";

export const LoadingWidget = () => {
	return <div className="loading_widget">{<LoaderRing />}</div>;
};
